import { AccountSettingsStoreSlice } from './types';

export const defaultDeactivationState: AccountSettingsStoreSlice['deactivationStatus'] = {
  isDeactivated: false,
  canReactivate: false,
  timeUntilReactivation: 0,
};
